<template>
    <div class="home">
        <div class="item" v-for="slide in homeImgs" :key="slide.id" @click="$emit('click', slide.id)"
             :style="{backgroundImage: `url(${require('../assets/images/' + slide.img)})`}">
            <div class="text" v-html="slide.text"></div>
        </div>
    </div>
</template>

<script>
import homeImgs from '../json/home'

export default {
    name: 'HomeSlide',

    data () {
        return {
            homeImgs
        }
    }
}
</script>

<style scoped lang="scss">
    .home {
        position: absolute;
        width: 100%;
        height: 100%;


        .item {
            float: left;
            width: 33.3%;
            height: 50%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: opacity 0.5s ease;

            .text {
                color: #fff;
                font-weight: 700;
                font-size: 30px;
                opacity: 0;
                text-align: center;
                transition: opacity 0.5s ease;
                line-height: 48px;
            }

        }

        .item:hover {
            opacity: 0.7;

            .text {
                opacity: 1;
            }

        }
    }
    

    @media (max-width: 768px) {
        .home {

            .item {

                .text {
                    font-size: 14px;
                    line-height: 24px;
                }

            }
        }
    }
    @media (max-width: 480px) {
        .home {
                top: 40px;
        height: calc(100% - 40px);
            .item {
                width: 50%;
                height: 33.3%;
                .text {
                    font-size: 14px;
                }

            }
        }
        .sub-slide {
            position: absolute;
            width: 100%;
            height: calc(100% - 40px);
        }
    }
</style>
